module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/features/headers-styles/ecommerce-header-style7/ecommerce-header-style7.component.scss
// module id = ./src/app/features/headers-styles/ecommerce-header-style7/ecommerce-header-style7.component.scss
// module chunks = main